import { DealTableCell } from '@crm/entities/deal';
import { DateHelpers } from '@crm/shared/lib';
import { formatPrice } from '@shared/helpers';

import type { TInWorkOrFinishedDeal } from '@crm/entities/deal';

export const DealPaymentDataCell = ({
    amount,
    currency,
    date,
}: {
    amount: TInWorkOrFinishedDeal['payment']['amount'];
    currency: TInWorkOrFinishedDeal['payment']['currency'];
    date: TInWorkOrFinishedDeal['payment']['date'];
}) => (
    <DealTableCell
        className="px-1 whitespace-nowrap"
        isEmpty={amount === null && date === null}
        fallback="-"
    >
        <div className="flex gap-0.5 flex-col">
            <span>
                {amount === null
                    ? '-'
                    : formatPrice(amount, {
                          currencyCode: currency ?? undefined,
                          withCurrency: true,
                      })}
            </span>
            {date && (
                <span className="text-smtr-main-tertiary-50">
                    {DateHelpers.formatDisplayDate(DateHelpers.parseApiDate(date))}
                </span>
            )}
        </div>
    </DealTableCell>
);
